module.exports = __webpack_public_path__ + "img/Group 2.64bbb77b.png";